<template>
  <div id="qr-modal" class="modal fade">
    <div class="modal-dialog">
      <div class="modal-content" style="background: white">
        <div class="modal-header" style="padding: 10px 30px">
          <button type="button" class="close" data-dismiss="modal" ref="close" aria-hidden="true">&times;</button>
          <h3 class="modal-title">Zwei-Faktor-Authentifizierung aktivieren</h3>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-7 hyphens" style="text-align: left;" lang="de">
              <h4>Authentifizierungs-App installieren und konfigurieren</h4>
              <p style="padding-top: 10px;"><b>Schritt 1:</b> Installieren Sie eine Authentifizierung-App auf Ihrem Mobilgerät. Wir
                empfehlen die Google
                Authenticator App
                ( <a
                    href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&amp;hl=de&amp;gl=US"
                    target="_blank">Android</a> | <a
                    href="https://apps.apple.com/de/app/google-authenticator/id388497605" target="_blank">iOS</a> )</p>
              <p class="hyphens"><b>Schritt 2:</b> Öffnen und konfigurieren Sie die Authentifizierungs-App durch Scannen
                des QR-Codes.</p>
              <p class="hyphens"><b>Schritt 3:</b> Geben Sie Ihren Sicherheitscode
                aus der Authentifizierungs-App ein und klicken Sie auf den "Bestätigen"-Button, um die Aktivierung abzuschließen.</p>
            </div>
            <div class="col-md-5">
              <div v-html="qrCode"></div>
              <small>QR-Code zum Einscannen</small>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-9" style="padding-right: 0">
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Sicherheitscode eingeben..." v-model="code">
              </div>
            </div>
            <div class="col-md-3" style="padding-left: 10px">
              <button type="button" class="btn btn-primary btn-block" @click="verifyCodeAndEnable">
                Bestätigen
              </button>
            </div>
          </div>
          <div class="alert alert-danger" v-if="errorMsg">
            {{errorMsg}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
  name: 'TwoFactorAuthEnableModal',
  components: {},
  data() {
    return {
      code: '',
      errorMsg: '',
    }
  },
  methods: {
    ...mapMutations([
      'setActivated'
    ]),
    verifyCodeAndEnable() {
      axios.post('/backend/profile/2fa/verify-and-toggle', {
        secret: this.secret,
        code: this.code,
        action: 'enable'
      }).then(res => {
        let data = res.data;
        if (data.status === 'error') {
          this.errorMsg = 'Der Sicherheitscode ist ungültig.'
        } else {
          this.errorMsg = '';
          this.setActivated(true);
          this.$emit('success', 'enable')
          this.$refs.close.click()
        }
      }).catch(() => {
        this.errorMsg = 'Der Sicherheitscode ist ungültig.'
      })
    }
  },
  computed: {
    ...mapGetters({
      qrCode: 'getQrCode',
      secret: 'getSecret',
    })
  }
}
</script>

<style scoped>
.hyphens {
  -moz-hyphens: auto;
  hyphens: auto;
}
</style>
